<template>
    <DialogLayout>
        <form @submit.prevent="handleSubmit">
            <div class="row">
                <div class="col-md-8">
                    <h3 class="Modal__title">Je souhaite un rendez-vous</h3>
                    <div class="Alert Alert--error m-b-15" v-if="errorOccured">
                        Une erreur est survenue, veuillez réessayer.
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <input-material @input="value => handleChange('name', value)" :required="true" label="Nom"
                                            :error="errors.name" v-model="data.name"/>
                        </div>
                        <div class="col-md-6">
                            <input-material @input="value => handleChange('email', value)" :required="true"
                                            label="Adresse e-mail" type="email" :error="errors.email"
                                            v-model="data.email"/>
                        </div>
                        <div class="col-md-6">
                            <input-material @input="value => handleChange('phone', value)" label="Téléphone"
                                            :error="errors.phone" v-model="data.phone"/>
                        </div>
                        <div class="col-md-6">
                            <div class="FormMaterial__group">
                                <multiselect
                                    open-direction="bottom"
                                    class="Select Select--material Select--small"
                                    :searchable="false"
                                    :show-labels="false"
                                    :placeholder="$campusLabel"
                                    @select="value => handleChange('campus_id', value)"
                                    key="id"
                                    :allow-empty="false"
                                    :loading="loadingCampuses"
                                    :options="campuses"
                                    label="name"
                                    v-model="data.campus">
                                    <span slot="noOptions">Aucun élément.</span>
                                </multiselect>
                                <span class="form-error" v-if="errors.campus_id">{{ errors.campus_id[0] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="FormMaterial__group">
                        <multiselect
                            open-direction="bottom"
                            class="Select Select--material Select--small"
                            :searchable="false"
                            :show-labels="false"
                            placeholder="Sujet"
                            @select="value => handleChange('subject', value)"
                            :allow-empty="false"
                            :options="subjects"
                            v-model="data.subject">
                            <span slot="noOptions">Aucun élément.</span>
                        </multiselect>
                        <span class="form-error" v-if="errors.subject">{{ errors.subject[0] }}</span>
                    </div>
                    <input-material @input="value => handleChange('message', value)" :required="true" label="Message"
                                    :error="errors.message" v-model="data.message"
                                    type="textarea"/>

                </div>
                <div class="col-md-4">
                    <h4 class="bold m-t-15 m-b-25">Choix de la date</h4>
                    <div class="m-b-30">
                        <datepicker class="calendar"
                                    @selected="handleChangeDate"
                                    :typeable="false" :monday-first="true" minimum-view="day" maximum-view="day"
                                    :full-month-name="true" :language="datepickerFr"
                                    v-model="data.date"
                                    :disabled-dates="disabledDates"
                                    :inline="true"></datepicker>
                        <span class="form-error" v-if="errors.date">{{ errors.date[0] }}</span>
                    </div>
                </div>
            </div>
            <button :disabled="sending" class="Btn Btn--primary Btn--gradient Btn--shadow">
                <i v-if="sending" class="fas fa-spinner fa-spin"></i>
                <span v-else>Envoyer <i class="fas fa-caret-right m-l-5"></i></span>
            </button>
        </form>
    </DialogLayout>
</template>

<script>
    import datepickerFr from 'vuejs-datepicker/dist/locale/translations/fr';
    import Datepicker from 'vuejs-datepicker';
    import InputMaterial from "../../InputMaterial";
    import {actions, getters} from "../../../store";
    import Api from "../../../services/Api";
    import ModalBus from "../../../eventBus";
    import validate from "../../../validator/validator";
    import Rules from '../../../validator/rules';
    import {isEmpty} from "../../../utils";
    import {endOfDay, format, isAfter} from 'date-fns';
    import DialogLayout from "../Layouts/DialogLayout";
    import Token from "../../../services/Token";

    export default {
        components: {DialogLayout, InputMaterial, Datepicker},
        data: function () {
            return {
                datepickerFr,
                loadingCampuses: false,
                sending: false,
                errorOccured: false,
                data: {
                    name: null,
                    phone: null,
                    email: null,
                    date: null,
                    campus: null,
                    subject: null,
                    message: null
                },
                errors: {},
                subjects: [
                    "À propos d'un apprentissage",
                    "Contrat d'apprentissage",
                    "Formations professionnelles",
                    "Formations réglementaires",
                    "Autres"
                ]
            };
        },
        computed: {
            disabledDates: function () {
                return {
                    customPredictor: function (date) {
                        let today = endOfDay(new Date());
                        if (isAfter(today, date)) {
                            return true
                        }
                    }
                }
            },
            campuses: getters.campuses
        },
        methods: {
            handleChange: function (name) {
                delete this.errors[name];
            },
            handleChangeDate: function () {
                delete this.errors.date;
            },
            handleSubmit: async function () {
                let {name, phone, email, campus, subject, message, date} = this.data,
                    data = {
                        name,
                        email,
                        phone,
                        campus_id: campus?.id,
                        date: date ? format(this.data.date, 'yyyy-MM-dd') : null,
                        subject,
                        message,
                        type: this.$enums.ContactType.Appointment
                    },
                    errors = validate(data, {
                        name: [Rules.required()],
                        email: [Rules.required(), Rules.email()],
                        phone: [Rules.nullable(), Rules.phone()],
                        campus_id: [Rules.required(), Rules.oneOf(this.campuses.map(campus => campus.id))],
                        date: [Rules.required('Veuillez choisir une date')],
                        subject: [Rules.required(), Rules.oneOf(this.subjects)],
                        message: [Rules.required(), Rules.minLength(30)]
                    });

                this.errorOccured = false;

                if (!isEmpty(errors)) {
                    this.errors = errors;
                    return;
                }

                this.sending = true;

                try {
                    await this.$recaptchaLoaded();
                    data['g-recaptcha-response'] = await this.$recaptcha('contact');

                    await Api.post('/contact', data);
                    ModalBus.alertSuccess('Message envoyé', 'Nous vous remercions de nous avoir contacté, votre message sera traité dans les meilleurs délais.');
                } catch (err) {
                    this.sending = false;
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                    } else {
                        this.errorOccured = true;
                    }
                }
            }
        },
        async created() {
            if(!this.$user && Token.has()){
                await actions.fetchUser();
            }

            this.data = {
                ...this.data,
                name: this.$user?.profile?.name,
                phone: this.$user?.profile?.phone,
                email: this.$user?.email
            };

            if (this.campuses.length <= 0) {
                this.loadingCampuses = true;
                await actions.fetchCampuses();
                this.loadingCampuses = false;
            }
        }
    }
</script>
